import { useCallback, useEffect, useRef, useState } from 'react';

import { areSetsEqual } from '../helpers/utils';

export const useKeyboardShortcut = (
  callback: () => void,
  keys: string[],
  deps: any[] = []
) => {
  // Keep track of the keys pressed
  const [keysPressed, setKeyPressed] = useState<string[]>([]);

  // If the keys pressed match our target keys then we invoke the callback
  useEffect(() => {
    if (areSetsEqual(keysPressed, keys)) {
      callback();
      setKeyPressed([]);
    }
  }, [callback, deps, keysPressed, keys]);

  // If a key is pressed, add it to our set of keys pressed
  const downHandler = useCallback(
    ({ key }) => {
      setKeyPressed([...keysPressed, key]);
    },
    [keysPressed]
  );

  // If a key is released, remove it from our set of keys pressed
  const upHandler = useCallback(
    ({ key }) => {
      setKeyPressed(keysPressed.filter((k) => k !== key));
    },
    [keysPressed]
  );

  // Add event listeners
  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [downHandler, upHandler]);
};
